angular.module('rjmNg.api').factory 'Rjql', [
  "$resource"
  "serviceUrl"
  (
    $resource,
    serviceUrl
  ) ->

    (clientId) ->

      rjqlBaseUrl = serviceUrl("/clients/#{clientId}/rjql")

      defaultParams =
        withCredentials: true
        headers:
          Accept: 'application/json'
          'Content-Type': 'application/json'

      actions =
        createRjqlJobs: angular.extend {}, defaultParams,
          method: 'POST'
          url: rjqlBaseUrl + '/jobs?use_cache=1'
        getRjqlJobs: angular.extend {}, defaultParams,
          method: 'GET'
          url: rjqlBaseUrl + '/jobs'
        getRjqlJobPayloads: angular.extend {}, defaultParams,
          method: 'GET'
          url: rjqlBaseUrl + "/jobs/payloads"

      rjqlResource = $resource(rjqlBaseUrl, {}, actions)

      _cleanupFilter = (filter) ->
        field: filter.field
        operator: filter.operator
        value: filter.value

      createRjqlJobs: (rjqlIds, filters = [], timerange = null, interval = null, force = false) ->
        payload =
          rjql_ids: rjqlIds

        if filters.length > 0
          payload.filters = filters.map(_cleanupFilter)

        if timerange?
          payload.timerange = timerange

        if interval?
          payload.interval = interval

        if force is true
          payload.force = true

        rjqlResource.createRjqlJobs({}, payload).$promise
      getRjqlJobs: (rjqlIds) ->
        rjqlResource.getRjqlJobs({id: rjqlIds}, {}).$promise
      getRjqlJobPayloads: (rjqlIds) ->
        rjqlResource.getRjqlJobPayloads({id: rjqlIds}, {}).$promise
]
